export const elevation = {
  none: 0,
  low: 1,
  medium: 3,
  high: 6,
};

